angular.module('eStories.account.history', [
        /*eStories Account Overview - Nested View of eStories.account - account.js*/

    ])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.account.history', {
                url: '/history',
                controller: 'AccountCtrl as accountCtrl',
                templateUrl: 'account/overview/myHistory.tmpl.html'

            });
    }]);